import { ChangeDetectorRef, Component } from '@angular/core';
import { SessionStorageService } from '@app/core/local-storage/local-storage.service';
import { BusinessService } from './business.service';
import { AppConfig } from '@app/config/app.config';
import { iconCodes } from '@app/shared/cqes-icon/cqes-icon.component';
import { routeAnimations } from '@app/core/animations/router.transition';
import { selectorAuth } from '@app/core';
import { IUserData } from '@app/profile/main/details';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'cloud-business',
  templateUrl: './business.component.html',
  styleUrls: ['./business.component.scss'],
  animations: [routeAnimations]
})
export class BusinessComponent {
  businessAccountId;
  mainLinks = [];
  readonly icons = iconCodes;
  selectedIndex = 1;
  companyId: any;
  companyData: any;
  cmrId: any;
  groups = [];
  hasIdentification: boolean;
  employeeId: any;
  isSuperAdmin: boolean = false;

  unsubscribe$: Subject<void> = new Subject<void>();
  private links = [
    {
      link: AppConfig.routes.business.sign,
      label: AppConfig.routes.business.sendForSigning,
      icon: this.icons.developer_board,
      enabled: true
    },
    // {
    //   // link: '/identification',
    //   link: AppConfig.routes.business.identification,
    //   label: AppConfig.routes.business.identification,
    //   icon: this.icons.face,
    //   enabled: true
    // },
    {
      // link: '/archive',
      label: AppConfig.routes.business.archive,
      icon: this.icons.menu,
      enabled: false
    },
    {
      // link: '/hardwareCertificates',
      label: AppConfig.routes.business.hardwareCertificates,
      icon: this.icons.usb,
      enabled: false
    },
    {
      // link: '/identification',
      link: AppConfig.routes.business.identification,
      label: AppConfig.routes.business.identification,
      icon: this.icons.face,
      // enabled: true
      enabled: false
    },
    {
      link: AppConfig.routes.business.history,
      label: AppConfig.routes.business.history,
      icon: this.icons.history,
      enabled: true
    },
    {
      link: AppConfig.routes.business.reports,
      label: AppConfig.routes.business.reports,
      icon: this.icons.dataset,
      // enabled: false
      enabled: true
    },
  ];

  isServicesUser: boolean;
  servicesUserData: any;
  userData: IUserData;
  id: any;
  constructor(
    private sessionStorageService: SessionStorageService,
    private businessService: BusinessService,
    private changeRef: ChangeDetectorRef,
    private store: Store<any>,
  ) {
    this.store
      .select(selectorAuth)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (res.userData) { this.userData = res.userData; }
        if (this.userData == undefined) {
          this.userData = this.sessionStorageService.getItem("loginEventData")
        }
      });
  }

  ngOnInit() {
    this.getCurrentLoggedInAccount();
    this.getEmployeeId()
    this.getCompanyData();
    this.getMainLinks();
    this.getCompanyData()
    // this.getAvalibaleServicesUser()

    this.businessService.updateNavBar
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (res) {
          this.getAvalibaleServicesUser();
          this.getMainLinks();
        }
      })
  }

  getCurrentLoggedInAccount() {
    this.businessAccountId = this.sessionStorageService.getItem("businessAccountId");
    this.sessionStorageService.businessAccountId.next(this.businessAccountId);

    const company = this.sessionStorageService.getItem("accounts").find((item: any) => item.cmrId === this.businessAccountId);
    this.isSuperAdmin = company?.role === 'MY_BTRUST_SUPER_ADMINISTRATOR';
  }
  getEmployeeId() {
    this.employeeId = this.sessionStorageService.getItem("loginEventData")?.userData?.cmrId;
  }

  getCompanyData() {
    this.businessService.getCompany(this.businessAccountId).subscribe(res => {
      this.companyData = res.data;
      this.getGroups();
      this.id = res.data.cmrId;
      this.getAvalibaleServicesUser();
      this.getMainLinks();
    })
  }

  getGroups() {
    this.businessService.getEmployeesServices(this.businessAccountId, this.employeeId).subscribe(res => {
      this.groups = res.data;
      this.hasIdentification = this.getIdentification(this.groups, "IDENTIFICATION") || this.getIdentification(this.groups, "WEB_IDENTIFICATION");

      this.disableReportLink()

      if (!this.hasIdentification) {
        this.disableIdentificationLink();
      }
    });
  }

  disableReportLink() {
    const reportsLink = this.links.find(link => link.label === AppConfig.routes.business.reports);
    if (reportsLink) {
      reportsLink.enabled = this.isSuperAdmin;
    }
  }

  getIdentification(groups: any[], service: string): boolean {
    if (!groups || !Array.isArray(groups)) {
      return false;
    }

    return groups.some((group: any) => {
      return group.serviceType === service;
    });
  }
  disableIdentificationLink() {
    const identificationLink = this.links.find(link => link.link === AppConfig.routes.business.identification);
    if (identificationLink) {
      identificationLink.enabled = false;
    }
  }

  getAvalibaleServicesUser() {
    this.cmrId = this.userData.cmrId;
    this.businessService.getAvalibaleServicesUser(this.id, this.cmrId).subscribe(res => {
      this.servicesUserData = res.data;
      // Check if user has access to QES_REPORT service specifically
      this.isServicesUser = this.servicesUserData.some(service => service.serviceType === "QES_REPORT");
      if (this.isServicesUser) {
        let hardwareCertificateIndex = this.links.findIndex(link => link.label === AppConfig.routes.business.hardwareCertificates);

        if (hardwareCertificateIndex !== -1) {
          this.links[hardwareCertificateIndex] = {
            link: AppConfig.routes.business.hardwareCertificates,
            label: AppConfig.routes.business.hardwareCertificates,
            icon: this.icons.developer_board,
            enabled: true
          }
        }
      } else {
        // If the user is not a services user, disable the hardware certificates link
        let hardwareCertificateIndex = this.links.findIndex(link => link.label === AppConfig.routes.business.hardwareCertificates);

        if (hardwareCertificateIndex !== -1) {
          this.links[hardwareCertificateIndex] = {
            link: null,
            label: AppConfig.routes.business.hardwareCertificates,
            icon: this.icons.developer_board,
            enabled: false
          }
        }
      }
      // === IDENTIFICATION ===
      let hasIdentification = this.servicesUserData.some(service => service.serviceType === "IDENTIFICATION" || service.serviceType === "WEB_IDENTIFICATION");
      if (hasIdentification) {
        let identificationIndex = this.links.findIndex(link => link.label === AppConfig.routes.business.identification);

        if (identificationIndex !== -1) {
          this.links[identificationIndex] = {
            link: AppConfig.routes.business.identification,
            label: AppConfig.routes.business.identification,
            icon: this.icons.face,
            enabled: true
          }
        }
      } else {
        let identificationIndex = this.links.findIndex(link => link.label === AppConfig.routes.business.identification);

        if (identificationIndex !== -1) {
          this.links[identificationIndex] = {
            link: null,
            label: AppConfig.routes.business.identification,
            icon: this.icons.face,
            enabled: false
          }
        }
      }
    });
  }

  getMainLinks() {
    this.mainLinks = this.links;
  }

  prepareOutlet(o) {
    return o.isActivated && o.activatedRoute.routeConfig.path;
  }

  ngAfterViewInit(): void {
    this.changeRef.detectChanges();
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
